module.exports = __webpack_public_path__ + "img/head-single-eye.b667db0d.png";